export default __webpack_public_path__ + "static/media/Advergic-Logo.77f13d36.svg";